import {
  Task,
  TaskContent,
  TaskItem,
  TaskTrigger
} from "@/components/ai-elements/task";
import type { PlanStep } from "@/shared/mock-data";
import { CheckCircle2, Circle, LoaderCircle } from "lucide-react";

interface PlanPanelProps {
  title: string;
  steps: PlanStep[];
}

function StepIcon({ status }: { status: PlanStep["status"] }) {
  if (status === "completed")
    return <CheckCircle2 className="size-4 text-emerald-500" />;
  if (status === "in-progress")
    return <LoaderCircle className="size-4 animate-spin text-blue-500" />;
  return <Circle className="size-4 text-muted-foreground" />;
}

export function PlanPanel({ title, steps }: PlanPanelProps) {
  return (
    <Task className="rounded-xl border bg-card p-4" defaultOpen>
      <TaskTrigger title={title} />
      <TaskContent>
        {steps.map((step) => (
          <TaskItem
            key={step.id}
            className="flex items-start justify-between gap-3"
          >
            <span className="flex items-center gap-2 text-foreground">
              <StepIcon status={step.status} />
              {step.title}
            </span>
            <span className="text-xs">{step.owner}</span>
          </TaskItem>
        ))}
      </TaskContent>
    </Task>
  );
}
